/**
 * 多列视频系统 - 高性能懒加载版本
 * 功能包括：标签切换、分页、按日期排序、弹窗播放、点击跳转
 * 支持大量视频（100+）的流畅显示
 */

document.addEventListener("DOMContentLoaded", function () {
  
  /**
   * 初始化多列视频系统
   * 为每个视频section创建独立的实例
   */
  function initMultiColumnVideoSystem() {
    // 查找所有视频section
    var videoSections = document.querySelectorAll('.section-multi-column[id^="section-id-"]');
    
    videoSections.forEach(function(sectionEl) {
      // 检查是否是多列视频section
      if (!sectionEl.classList.contains('section-multi-column')) {
        return;
      }
      
      // 提取section ID
      var sectionId = sectionEl.id.replace('section-id-', '');
      
      // 初始化该section的视频系统
      initVideoSection(sectionEl, sectionId);
    });

    // 全局Tab按钮事件（Header/任意位置）- 只注册一次
    if (!window.videoTabGlobalHandler) {
      window.videoTabGlobalHandler = function(e) {
        var btn = e.target.closest('.video-tab-menu');
        if (!btn) return;
        
        // 检查是否在视频页面
        var isVideoPage = window.location.pathname.includes('leivip-video-page') || 
                         document.querySelector('.section-multi-column[id^="section-id-"]');
        
        if (isVideoPage) {
          // 在视频页面：先更新菜单状态，再刷新页面
          var tab = (btn.getAttribute('data-tab-trigger') || '').trim();
          if (tab.toLowerCase() === 'all') tab = '';
          
          // 立即更新所有菜单按钮的活跃状态
          document.querySelectorAll('.video-tab-menu').forEach(function(menuBtn) {
            menuBtn.classList.remove('active-tab');
          });
          btn.classList.add('active-tab');
          
          // 更新URL参数并刷新页面
          var url = new URL(window.location.href);
          // 需要为所有视频系统设置参数
          if (window.videoSystems) {
            Object.keys(window.videoSystems).forEach(function(id){
              var sys = window.videoSystems[id];
              if (sys && sys.config) {
                if (tab) {
                  url.searchParams.set(sys.config.tabParamKey, tab);
                } else {
                  url.searchParams.delete(sys.config.tabParamKey);
                }
                // 标签切换时重置页码到第一页
                url.searchParams.delete(sys.config.paramKey);
              }
            });
          }
          
          // 刷新页面
          window.location.href = url.toString();
          e.preventDefault();
        } else {
          // 在其他页面：使用原来的切换逻辑
          var tab = (btn.getAttribute('data-tab-trigger') || '').trim();
          if (tab.toLowerCase() === 'all') tab = '';
          if (window.videoSystems) {
            Object.keys(window.videoSystems).forEach(function(id){
              var sys = window.videoSystems[id];
              if (sys && typeof sys.activateTab === 'function') {
                sys.activateTab(tab);
              }
            });
          }
          // 同步所有按钮的高亮
          document.querySelectorAll('.video-tab-menu').forEach(function(el){ el.classList.remove('active-tab'); });
          btn.classList.add('active-tab');
          e.preventDefault();
        }
      };
      document.addEventListener('click', window.videoTabGlobalHandler);
    }
  }

  /**
   * 初始化单个视频section
   * @param {HTMLElement} sectionEl - section DOM元素
   * @param {string} sectionId - section ID
   */
  function initVideoSection(sectionEl, sectionId) {
    // 获取配置数据
    var config = getSectionConfig(sectionEl, sectionId);
    if (!config) return;

    // 创建视频系统实例
    var videoSystem = new VideoSystem(sectionEl, sectionId, config);
    videoSystem.init();
  }

  /**
   * 获取section配置数据
   * @param {HTMLElement} sectionEl - section DOM元素
   * @param {string} sectionId - section ID
   * @returns {Object|null} 配置对象
   */
  function getSectionConfig(sectionEl, sectionId) {
    // 获取必要的DOM元素
    var listEl = sectionEl.querySelector('#video-list-' + sectionId);
    var containerEl = document.getElementById('video-container-' + sectionId);
    var paginationEl = document.getElementById('video-pagination-' + sectionId);
    var loadingEl = document.getElementById('video-loading-' + sectionId);
    var dataEl = document.getElementById('video-data-' + sectionId);

    // 检查必要元素是否存在
    if (!listEl || !containerEl || !dataEl) {
      console.warn('视频系统初始化失败：缺少必要的DOM元素', sectionId);
      return null;
    }

    // 解析配置数据
    var videoData;
    try {
      videoData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('视频数据解析失败：', e);
      return null;
    }

    // 获取设置参数
    var itemsPerPage = parseInt(listEl.getAttribute('data-items-per-page') || '6', 10);
    if (!Number.isFinite(itemsPerPage) || itemsPerPage <= 0) itemsPerPage = 6;

    // 从section元素获取其他配置
    var clickAction = sectionEl.getAttribute('data-click-action') || 'modal';
    var buttonStyle = sectionEl.getAttribute('data-button-style') || 'primary';
    var forceShowPagination = sectionEl.getAttribute('data-force-show-pagination') === 'true';
    var defaultTabName = (sectionEl.getAttribute('data-default-tab') || '').trim();
    // 调试开关（可在控制台设置 window.DEBUG_VIDEO = true）
    var debug = true; // 默认开启，便于排查；必要时可改为：(sectionEl.getAttribute('data-debug') === 'true') || (window.DEBUG_VIDEO === true)

    return {
      listEl: listEl,
      containerEl: containerEl,
      paginationEl: paginationEl,
      loadingEl: loadingEl,
      dataEl: dataEl,
      videoData: videoData,
      itemsPerPage: itemsPerPage,
      clickAction: clickAction,
      buttonStyle: buttonStyle,
      forceShowPagination: forceShowPagination,
      defaultTabName: defaultTabName,
      debug: debug,
      paramKey: 'vpage_' + sectionId,
      tabParamKey: 'vtab_' + sectionId
    };
  }

  /**
   * 视频系统主类
   * 负责管理单个section的所有视频功能
   */
  function VideoSystem(sectionEl, sectionId, config) {
    this.sectionEl = sectionEl;
    this.sectionId = sectionId;
    this.config = config;
    
    // 状态变量
    this.currentTab = null;
    this.currentPage = 1;
    this.modalBackdrop = null;
    this.modalBody = null;
    this.closeBtn = null;
    this.lastFocused = null;
    this.debug = !!config.debug;
    var self = this;
    this.log = function() {
      if (!self.debug) return;
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[VideoSys][' + self.sectionId + ']');
      try { console.log.apply(console, args); } catch (e) { /* no-op */ }
    };
    
    // 绑定this上下文
    this.openModalWithContent = this.openModalWithContent.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.activateTab = this.activateTab.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  /**
   * 初始化视频系统
   */
  VideoSystem.prototype.init = function() {
    // 防重入：同一个 section 只初始化一次
    if (window.videoSystems && window.videoSystems[this.sectionId] && window.videoSystems[this.sectionId].initialized) {
      this.log('init() skipped: already initialized');
      return;
    }
    this.log('init()', {
      itemsPerPage: this.config.itemsPerPage,
      clickAction: this.config.clickAction,
      buttonStyle: this.config.buttonStyle,
      videoCount: Array.isArray(this.config.videoData) ? this.config.videoData.length : -1
    });
    // 注册到全局实例管理器
    if (!window.videoSystems) {
      window.videoSystems = {};
    }
    window.videoSystems[this.sectionId] = this;
    
    // 初始化弹窗系统
    this.initModal();
    
    // 初始化懒加载系统
    this.initLazyLoading();
    
    // 初始化标签切换
    this.initTabSwitching();
    
    // 执行初始渲染
    this.performInitialRender();
    this.initialized = true;
  };

  /**
   * 初始化弹窗系统
   */
  VideoSystem.prototype.initModal = function() {
    this.modalBackdrop = document.getElementById('video-modal-' + this.sectionId);
    this.modalBody = this.modalBackdrop ? this.modalBackdrop.querySelector('.video-modal__body') : null;
    this.closeBtn = this.modalBackdrop ? this.modalBackdrop.querySelector('.video-modal__close') : null;

    // 绑定弹窗事件
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.closeModal);
    }
    
    if (this.modalBackdrop) {
      this.modalBackdrop.addEventListener('click', function(e) {
        if (e.target === this.modalBackdrop) this.closeModal();
      }.bind(this));
    }

    // ESC键关闭弹窗（全局监听，避免重复绑定）
    if (!window.videoSystemEscHandler) {
      window.videoSystemEscHandler = function(e) {
        if (e.key === 'Escape') {
          // 查找当前激活的弹窗并关闭
          var activeModal = document.querySelector('.video-modal-backdrop.is-active');
          if (activeModal) {
            var modalId = activeModal.id.replace('video-modal-', '');
            var videoSystem = window.videoSystems && window.videoSystems[modalId];
            if (videoSystem) {
              videoSystem.closeModal();
            }
          }
        }
      };
      document.addEventListener('keydown', window.videoSystemEscHandler);
    }
  };

  /**
   * 初始化懒加载系统
   */
  VideoSystem.prototype.initLazyLoading = function() {
    // 懒加载系统在renderContent中实现
    // 这里可以添加预加载逻辑
  };

  /**
   * 初始化标签切换系统
   */
  VideoSystem.prototype.initTabSwitching = function() {
    // 由 Header 全局代理，这里仅打印现状
    var tabMenus = document.querySelectorAll('.video-tab-menu');
    this.log('initTabSwitching()', 'tab buttons (global) =', tabMenus.length);
  };

  /**
   * 执行初始渲染
   */
  VideoSystem.prototype.performInitialRender = function() {
    // 从URL获取当前状态
    var state = this.getCurrentStateFromUrl();
    this.currentPage = state.page;
    this.currentTab = state.tab || this.config.defaultTabName || null;
    this.log('performInitialRender()', { urlState: state });
    
    // 如果启用了标签切换（Header渲染）：优先 URL / 默认配置 / Header激活 / Header第一个
    var headerTabs = document.querySelectorAll('.video-tab-menu[data-tab-trigger]');
    var hasTabs = headerTabs.length > 0;
    if (hasTabs) {
      var headerActiveBtn = document.querySelector('.video-tab-menu.active-tab[data-tab-trigger]');
      if (!this.currentTab && headerActiveBtn) {
        this.currentTab = (headerActiveBtn.getAttribute('data-tab-trigger') || '').trim();
      }
      if (!this.currentTab) {
        var firstTabBtn = headerTabs[0];
        if (firstTabBtn) this.currentTab = (firstTabBtn.getAttribute('data-tab-trigger') || '').trim();
      }
      // ALL 视为显示全部
      if (this.currentTab && this.currentTab.toLowerCase() === 'all') {
        this.currentTab = '';
      }
      this.log('hasTabs=true, chosen currentTab =', this.currentTab || 'ALL');
      // 检查是否在视频页面
      var isVideoPage = window.location.pathname.includes('leivip-video-page') || 
                       document.querySelector('.section-multi-column[id^="section-id-"]');
      
      if (isVideoPage) {
        // 在视频页面：直接渲染，不调用activateTab（避免刷新页面）
        this.renderContent();
      } else {
        // 在其他页面：调用激活流程，确保过滤和高亮
        this.activateTab(this.currentTab || '');
      }
      return;
    } else {
      // 没有可见的标签菜单时，若URL未指定，则默认选第一个数据里的标签
      if (!this.currentTab && Array.isArray(this.config.videoData) && this.config.videoData.length > 0) {
        this.currentTab = (this.config.videoData[0].tab || '').trim();
      }
    }
    this.renderContent();
  };

  /**
   * 打开弹窗并播放视频
   * @param {HTMLElement} node - 触发元素
   */
  VideoSystem.prototype.openModalWithContent = function(node) {
    if (!this.modalBackdrop || !this.modalBody) return;
    
    // 清空弹窗内容
    while (this.modalBody.firstChild) {
      this.modalBody.removeChild(this.modalBody.firstChild);
    }

    var shopifyMp4 = node.getAttribute('data-shopify-mp4');
    var externalUrl = node.getAttribute('data-external-url');

    // 处理Shopify视频
    if (shopifyMp4) {
      var video = document.createElement('video');
      video.src = shopifyMp4;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('webkit-playsinline', '');
      this.modalBody.appendChild(video);
    } 
    // 处理外部视频（YouTube/Vimeo）
    else if (externalUrl) {
      try {
        var url = new URL(externalUrl);
        var host = url.hostname;
        var iframe = document.createElement('iframe');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.border = '0';

        // YouTube处理
        if (/youtube\.com$|youtu\.be$/.test(host)) {
          var videoId = '';
          if (host.indexOf('youtu.be') > -1) {
            videoId = url.pathname.replace('/', '');
          } else {
            videoId = url.searchParams.get('v') || '';
          }
          iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&controls=1&rel=0';
        } 
        // Vimeo处理
        else if (/vimeo\.com$|player\.vimeo\.com$/.test(host)) {
          var pathParts = url.pathname.split('/').filter(Boolean);
          var vimeoId = pathParts[pathParts.length - 1] || '';
          iframe.src = 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&title=0&byline=0&portrait=0';
        } 
        // 其他视频源
        else {
          iframe.src = externalUrl;
        }
        this.modalBody.appendChild(iframe);
      } catch (e) {
        // 回退到链接
        var fallback = document.createElement('a');
        fallback.href = externalUrl;
        fallback.textContent = 'Open video';
        fallback.target = '_blank';
        this.modalBody.appendChild(fallback);
      }
    }

    // 显示弹窗
    this.modalBackdrop.classList.add('is-active');
    this.modalBackdrop.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll-video-modal');

    // 记录触发元素并聚焦关闭按钮
    this.lastFocused = node;
    if (this.closeBtn) {
      this.closeBtn.focus({ preventScroll: true });
    }
  };

  /**
   * 关闭弹窗
   */
  VideoSystem.prototype.closeModal = function() {
    if (!this.modalBackdrop || !this.modalBody) return;
    
    this.modalBackdrop.classList.remove('is-active');
    this.modalBackdrop.setAttribute('aria-hidden', 'true');
    
    // 清空弹窗内容
    while (this.modalBody.firstChild) {
      this.modalBody.removeChild(this.modalBody.firstChild);
    }
    
    document.documentElement.classList.remove('no-scroll-video-modal');
    
    // 恢复焦点
    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus({ preventScroll: true });
    }
  };

  /**
   * 解析日期并排序视频数据
   * @param {Array} data - 视频数据数组
   * @returns {Array} 排序后的数据
   */
  VideoSystem.prototype.parseAndSortItems = function(data) {
    return data.map(function(item) {
      var dateStr = (item.publish_date || '').trim();
      var time = 0;
      var hasDate = false;
      
      if (dateStr) {
        // 尝试解析日期格式 YYYY-MM-DD
        var match = dateStr.match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
        if (match) {
          var year = parseInt(match[1], 10);
          var month = parseInt(match[2], 10) - 1; // JavaScript月份从0开始
          var day = parseInt(match[3], 10);
          time = new Date(year, month, day).getTime();
          hasDate = true;
        } else {
          // 尝试其他格式
          time = Date.parse(dateStr) || 
                 Date.parse(dateStr.replace(/\./g,'-').replace(/\//g,'-')) || 0;
          hasDate = time > 0;
        }
      }
      
      return { 
        data: item, 
        time: time, 
        hasDate: hasDate,
        tab: item.tab 
      };
    }).sort(function(a, b) { 
      // 有日期的视频按时间倒序排列
      if (a.hasDate && b.hasDate) {
        return b.time - a.time;
      }
      // 有日期的视频排在前面
      if (a.hasDate && !b.hasDate) {
        return -1;
      }
      // 没有日期的视频排在后面
      if (!a.hasDate && b.hasDate) {
        return 1;
      }
      // 都没有日期的视频保持原有顺序
      return 0;
    });
  };

  /**
   * 从URL获取当前状态
   * @returns {Object} 包含page和tab的对象
   */
  VideoSystem.prototype.getCurrentStateFromUrl = function() {
    try {
      var usp = new URLSearchParams(window.location.search);
      var page = parseInt(usp.get(this.config.paramKey), 10);
      var tab = usp.get(this.config.tabParamKey);
      return {
        page: (Number.isFinite(page) && page > 0) ? page : 1,
        tab: tab
      };
    } catch (e) {
      return { page: 1, tab: null };
    }
  };

  /**
   * 更新URL状态
   * @param {number} page - 页码
   * @param {string} tab - 标签名
   */
  VideoSystem.prototype.updateUrl = function(page, tab) {
    try {
      var url = new URL(window.location.href);
      if (page > 1) {
        url.searchParams.set(this.config.paramKey, String(page));
      } else {
        url.searchParams.delete(this.config.paramKey);
      }
      if (tab) {
        url.searchParams.set(this.config.tabParamKey, tab);
      } else {
        url.searchParams.delete(this.config.tabParamKey);
      }
      window.history.replaceState(null, '', url.toString());
    } catch (e) { 
      // 忽略URL更新错误
    }
  };

  /**
   * HTML转义函数，防止XSS攻击
   * @param {string} text - 需要转义的文本
   * @returns {string} 转义后的文本
   */
  VideoSystem.prototype.escapeHtml = function(text) {
    if (!text) return '';
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  /**
   * 生成单个视频的HTML
   * @param {Object} item - 视频数据对象
   * @returns {string} HTML字符串
   */
  VideoSystem.prototype.generateVideoHTML = function(item) {
    // 提取Shopify MP4 URL
    var shopifyMp4Url = '';
    if (item.video_shopify && item.video_shopify.sources) {
      for (var i = 0; i < item.video_shopify.sources.length; i++) {
        if (item.video_shopify.sources[i].mime_type.indexOf('mp4') > -1) {
          shopifyMp4Url = item.video_shopify.sources[i].url;
          break;
        }
      }
    }
    
    // 获取占位图
    var placeholderImage = item.placeholder_image || 
                          (item.video_shopify ? item.video_shopify.preview_image : '');
    var redirectUrl = item.link || '/collections/new-in';
    
    // 构建视频源数据
    var videoSources = '';
    if (item.video_shopify && item.video_shopify.sources) {
      var sources = [];
      for (var i = 0; i < item.video_shopify.sources.length; i++) {
        var source = item.video_shopify.sources[i];
        sources.push(source.format + ' ' + source.mime_type + ' ' + source.url);
      }
      videoSources = sources.join('|');
    }

    // 生成覆盖文本HTML
    var showOverlayText = !!(item.title || item.subheading || item.text);
    var overlayTextHTML = '';
    
    if (showOverlayText) {
      var alignment = item.text_alignment.split(' ');
      var overlayHTML = '<div class="overlay-text overlay-text--for-banner overlay--v-' + 
                       alignment[0] + ' overlay--h-' + alignment[1] + ' image-overlay__over">';
      overlayHTML += '<div class="overlay-text__inner">';
      overlayHTML += '<div class="overlay-text__text" style="--heading-max-width: ' + 
                    item.heading_max_width + 'px" data-cc-animate="cc-fade-in-up" data-cc-animate-delay="0.5s">';
      
      if (item.subheading) {
        overlayHTML += '<div class="overlay-text__subheading subheading subheading--over">' + 
                      this.escapeHtml(item.subheading) + '</div>';
      }
      
      if (item.title) {
        if (item.use_h1) {
          overlayHTML += '<h1 class="overlay-text__title">' + this.escapeHtml(item.title) + '</h1>';
        } else {
          overlayHTML += '<h2 class="overlay-text__title h2-style" style="font-size: 35px;">' + 
                        this.escapeHtml(item.title) + '</h2>';
        }
      }
      
      if (item.text) {
        overlayHTML += '<div class="overlay-text__rte rte' + 
                      (item.enlarge_text ? ' large-text' : '') + '">' + item.text + '</div>';
      }
      
      overlayHTML += '</div></div></div>';
      overlayTextHTML = overlayHTML;
    }

    // 构建视频HTML
    var videoHTML = '<div id="block-id-' + item.id + '" data-tab="' + item.tab + 
                   '" class="column text-column" data-cc-animate="cc-fade-in-up" data-section-type="background-video" data-cc-animate>';
    
    if (item.video_shopify || item.video_external) {
      // 根据是否使用比例高度选择容器类
      var containerClass = 'video-container video-container--background image-overlay image-overlay--bg-' + item.overlay_style;
      videoHTML += '<div class="' + containerClass + '"';
      
      if (item.video_shopify) {
        videoHTML += ' data-video-sources="' + videoSources + '" data-video-type="mp4"';
      } else if (item.video_external) {
        videoHTML += ' data-video-url="' + item.video_external + '"';
      }
      
      videoHTML += ' data-video-autoplay="true" data-video-loop="true" data-cc-animate>';
      
      // 在卡片内直接渲染实际播放器，且仅对“当前页”生成，保证性能
      videoHTML += '<div class="video-container__video">';
      if (item.video_shopify && shopifyMp4Url) {
        var posterAttr = placeholderImage ? (' poster=\"' + this.escapeHtml(placeholderImage) + '\"') : '';
        videoHTML += '<video autoplay playsinline muted loop preload="metadata"' + posterAttr + ' style="width:100%;height:100%">';
        videoHTML += '<source src="' + this.escapeHtml(shopifyMp4Url) + '" type="video/mp4">';
        videoHTML += '</video>';
      } else if (item.video_external) {
        try {
          var url = new URL(item.video_external);
          var host = url.hostname;
          if (/youtube\.com$|youtu\.be$/.test(host)) {
            var vid = '';
            if (host.indexOf('youtu.be') > -1) {
              vid = url.pathname.replace('/', '');
            } else {
              vid = url.searchParams.get('v') || '';
            }
            var yt = 'https://www.youtube.com/embed/' + vid + '?autoplay=1&playsinline=1&controls=0&rel=0&modestbranding=1&mute=1';
            videoHTML += '<iframe src="' + yt + '" title="YouTube video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen style="border:0"></iframe>';
          } else if (/vimeo\.com$|player\.vimeo\.com$/.test(host)) {
            var parts = url.pathname.split('/').filter(Boolean);
            var vimeoId = parts[parts.length - 1] || '';
            var vm = 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&muted=1&title=0&byline=0&portrait=0';
            videoHTML += '<iframe src="' + vm + '" title="Vimeo video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen style="border:0"></iframe>';
          } else {
            // 其他外链：直接用 iframe 加载
            videoHTML += '<iframe src="' + this.escapeHtml(item.video_external) + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen style="border:0"></iframe>';
          }
        } catch (e) {
          // 非法URL则忽略内嵌
        }
      }
      videoHTML += '</div>';
      
      videoHTML += overlayTextHTML;
      // 获取点击行为设置（从section配置中获取，默认为modal）
      var clickAction = this.config.clickAction || 'modal';
      videoHTML += '<div class="video-click-overlay" data-click-action="' + clickAction + '" data-shopify-mp4="' + 
                  this.escapeHtml(shopifyMp4Url) + '" data-external-url="' + this.escapeHtml(item.video_external || '') + 
                  '" data-redirect-url="' + this.escapeHtml(redirectUrl) + '" aria-label="Play or open video"></div>';
      videoHTML += '</div>';
    } else {
      videoHTML += '<div class="fully-padded-row--large align-center">No content</div>';
    }
    
    // 添加标题
    if (item.title) {
      videoHTML += '<h3 class="text-column__title">' + this.escapeHtml(item.title) + '</h3>';
    }
    
    // 添加文本
    if (item.text) {
      videoHTML += '<div class="text-column__text rte">' + item.text + '</div>';
    }
    
    // 添加按钮
    if (item.button_label) {
      var buttonStyle = this.config.buttonStyle || 'primary';
      var buttonClass = 'text-column__button';
      if (buttonStyle !== 'link') {
        buttonClass += ' btn btn--' + buttonStyle;
      } else {
        buttonClass += ' small-feature-link';
      }
      videoHTML += '<div class="text-column__button-row text-column__button-row--' + buttonStyle + '">';
      videoHTML += '<a class="' + buttonClass + '" href="' + this.escapeHtml(item.link) + '">' + this.escapeHtml(item.button_label) + '</a>';
      videoHTML += '</div>';
    }
    
    videoHTML += '</div>';
    return videoHTML;
  };

  /**
   * 显示加载状态
   */
  VideoSystem.prototype.showLoading = function() {
    if (this.config.loadingEl) {
      this.config.loadingEl.style.display = 'block';
    }
    if (this.config.containerEl) {
      this.config.containerEl.style.display = 'none';
    }
  };

  /**
   * 隐藏加载状态
   */
  VideoSystem.prototype.hideLoading = function() {
    if (this.config.loadingEl) {
      this.config.loadingEl.style.display = 'none';
    }
    if (this.config.containerEl) {
      this.config.containerEl.style.display = 'block';
    }
  };

  /**
   * 激活指定标签
   * @param {string} tabName - 标签名称
   */
  VideoSystem.prototype.activateTab = function(tabName) {
    // 允许 ALL 或空字符串表示显示全部
    var normalized = (tabName || '').trim();
    if (normalized.toLowerCase() === 'all') normalized = '';
    this.currentTab = normalized;
    this.log('activateTab()', this.currentTab || 'ALL');
    
    // 更新标签按钮状态
    document.querySelectorAll('.video-tab-menu').forEach(function(btn){
      btn.classList.remove('active-tab');
    });
    var selector = this.currentTab ? '.video-tab-menu[data-tab-trigger="' + this.currentTab + '"]' : '.video-tab-menu[data-tab-trigger="ALL"]';
    var activeBtn = document.querySelector(selector);
    if (activeBtn) activeBtn.classList.add('active-tab');

    // 重置到第一页
    this.currentPage = 1;
    this.updateUrl(this.currentPage, this.currentTab);
    
    // 重新渲染
    this.renderContent();
    
    // 触发resize事件解决iframe显示问题
    setTimeout(function() {
      window.dispatchEvent(new Event('resize'));
    }, 50);
  };

  /**
   * 渲染内容（懒加载核心函数）
   */
  VideoSystem.prototype.renderContent = function() {
    this.showLoading();
    
    // 使用 setTimeout 让UI有时间显示加载状态
    setTimeout(function() {
      // 获取当前标签下的项目（存在标签菜单或URL中指定了标签时按标签过滤）
      var hasTabs = true; // 由 Header 全局驱动
      var currentTabNorm = (this.currentTab || '').trim().toLowerCase();
      var filteredData = currentTabNorm ?
        this.config.videoData.filter(function(item) { return ((item.tab || '').trim().toLowerCase() === currentTabNorm); }) :
        this.config.videoData; // 空字符串或ALL时显示全部
      
      var parsed = this.parseAndSortItems(filteredData);
      this.log('renderContent()', {
        hasTabs: hasTabs,
        currentTab: currentTabNorm,
        filteredCount: filteredData.length,
        totalBeforeFilter: this.config.videoData.length
      });
      var total = parsed.length;
      var totalPages = Math.max(1, Math.ceil(total / this.config.itemsPerPage));
      
      // 确保当前页有效
      if (this.currentPage > totalPages) this.currentPage = totalPages;
      if (this.currentPage < 1) this.currentPage = 1;

      // 只渲染当前页的项目（每页最多 itemsPerPage 个）
      var pageSize = Math.max(1, parseInt(this.config.itemsPerPage, 10) || 6);
      var start = (this.currentPage - 1) * pageSize;
      var end = start + pageSize;
      var currentPageData = parsed.slice(start, end);
      this.log('paging', { page: this.currentPage, pageSize: pageSize, total: total, totalPages: totalPages, slice: [start, end] });

      // 清空容器
      this.config.containerEl.innerHTML = '';

      // 生成当前页的HTML（只为当前页生成DOM，不为其他页生成，减少请求体积）
      var html = '';
      for (var i = 0; i < currentPageData.length; i++) {
        html += this.generateVideoHTML(currentPageData[i].data);
      }
      
      this.config.containerEl.innerHTML = html;

      // 新增：为当前页渲染出的元素补上显示类，避免被全局样式隐藏
      var renderedItems = this.config.containerEl.querySelectorAll(':scope > .column.text-column');
      renderedItems.forEach(function(el){
        el.classList.add('video-tab--active');
        
        // 移动端优化：确保按钮区域显示和视频高度一致
        if (window.innerWidth <= 768) {
          // 应用视频容器统一高度
          var videoContainers = el.querySelectorAll('.video-container');
          videoContainers.forEach(function(container) {
            container.style.height = '240px';
            container.style.minHeight = '240px';
            container.style.maxHeight = '240px';
          });
          
          // 确保按钮区域显示
          var buttonRow = el.querySelector('.text-column__button-row');
          if (buttonRow) {
            buttonRow.style.display = 'block';
            buttonRow.style.visibility = 'visible';
            buttonRow.style.opacity = '1';
            buttonRow.style.marginBottom = '20px';
            buttonRow.style.paddingBottom = '10px';
          }
          
          // 确保按钮本身显示
          var button = el.querySelector('.text-column__button');
          if (button) {
            button.style.display = 'inline-block';
            button.style.visibility = 'visible';
            button.style.opacity = '1';
            button.style.margin = '8px 0';
            button.style.width = 'auto';
            button.style.minWidth = '120px';
          }
        }
      });
      // 兜底：若视频容器为空（无 sources/url），不显示点击层
      this.config.containerEl.querySelectorAll('.video-container').forEach(function(vc){
        var hasSrc = vc.getAttribute('data-video-sources') || vc.getAttribute('data-video-url');
        if (!hasSrc) {
          var overlay = vc.querySelector('.video-click-overlay');
          if (overlay) overlay.style.display = 'none';
        }
      });

      // 绑定点击播放（弹窗）事件
      this.bindVideoEvents();
      this.log('rendered items =', renderedItems.length);

      // 重新绑定点击事件
      this.bindVideoEvents();
      
      // 尝试多种方式确保视频自动播放
      this.ensureVideoAutoplay();
      
      this.log('pagination', { totalPages: totalPages });

      // 显示“第X页/共Y页（共Z条）”
      var pageInfoEl = document.getElementById('video-pagination-info-' + this.sectionId);
      if (pageInfoEl) {
        pageInfoEl.textContent = 'Page ' + this.currentPage + ' / ' + totalPages + ' (' + total + ' items)';
      }

      // 渲染分页导航（即使只有一页也渲染数字按钮，受 forceShowPagination 控制）
      this.renderPagination(totalPages);

      this.hideLoading();
    }.bind(this), 100);
  };

  /**
   * 渲染分页导航
   * @param {number} totalPages - 总页数
   */
  VideoSystem.prototype.renderPagination = function(totalPages) {
    if (!this.config.paginationEl || (totalPages <= 1 && !this.config.forceShowPagination)) {
      if (this.config.paginationEl) {
        while (this.config.paginationEl.firstChild) {
          this.config.paginationEl.removeChild(this.config.paginationEl.firstChild);
        }
      }
      return;
    }

    // 清空分页导航
    while (this.config.paginationEl.firstChild) {
      this.config.paginationEl.removeChild(this.config.paginationEl.firstChild);
    }

    // 创建分页按钮
    var prevDisabled = this.currentPage <= 1;
    this.config.paginationEl.appendChild(this.createPaginationBtn('Prev', this.currentPage - 1, prevDisabled, false, 'Previous page'));

    for (var i = 1; i <= totalPages; i++) {
      this.config.paginationEl.appendChild(this.createPaginationBtn(String(i), i, false, i === this.currentPage, 'Page ' + i));
    }

    var nextDisabled = this.currentPage >= totalPages;
    this.config.paginationEl.appendChild(this.createPaginationBtn('Next', this.currentPage + 1, nextDisabled, false, 'Next page'));
  };

  /**
   * 创建分页按钮
   * @param {string} label - 按钮文本
   * @param {number} targetPage - 目标页码
   * @param {boolean} disabled - 是否禁用
   * @param {boolean} isActive - 是否激活
   * @param {string} ariaLabel - 无障碍标签
   * @returns {HTMLElement} 按钮元素
   */
  VideoSystem.prototype.createPaginationBtn = function(label, targetPage, disabled, isActive, ariaLabel) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'video-pagination__btn' + (isActive ? ' is-active' : '');
    btn.textContent = label;
    if (ariaLabel) btn.setAttribute('aria-label', ariaLabel);
    if (disabled) btn.setAttribute('disabled', 'disabled');
    
    btn.addEventListener('click', function() {
      if (disabled) return;
      
      // 检查是否在视频页面
      var isVideoPage = window.location.pathname.includes('leivip-video-page') || 
                       document.querySelector('.section-multi-column[id^="section-id-"]');
      
      if (isVideoPage) {
        // 在视频页面：刷新页面方式
        var url = new URL(window.location.href);
        if (targetPage > 1) {
          url.searchParams.set(this.config.paramKey, targetPage);
        } else {
          url.searchParams.delete(this.config.paramKey);
        }
        // 保持当前标签状态 - 从URL中获取当前标签
        var currentTab = this.currentTab || '';
        // 如果currentTab为空，尝试从URL中获取
        if (!currentTab) {
          var urlTab = url.searchParams.get(this.config.tabParamKey);
          if (urlTab) {
            currentTab = urlTab;
          }
        }
        if (currentTab) {
          url.searchParams.set(this.config.tabParamKey, currentTab);
        } else {
          url.searchParams.delete(this.config.tabParamKey);
        }
        
        // 刷新页面
        window.location.href = url.toString();
      } else {
        // 在其他页面：使用原来的切换逻辑
        this.currentPage = targetPage;
        this.updateUrl(this.currentPage, this.currentTab);
        this.renderContent();
      }
    }.bind(this));
    
    return btn;
  };

  /**
   * 重新绑定视频点击事件
   */
  VideoSystem.prototype.bindVideoEvents = function() {
    var overlays = this.config.containerEl.querySelectorAll('.video-click-overlay');
    overlays.forEach(function(overlay) {
      overlay.addEventListener('click', function() {
        var action = overlay.getAttribute('data-click-action') || 'modal';
        if (action === 'redirect') {
          var href = overlay.getAttribute('data-redirect-url') || '/collections/new-in';
          window.location.href = href;
        } else {
          this.openModalWithContent(overlay);
        }
      }.bind(this));
    }.bind(this));
  };

  /**
   * 确保视频自动播放 - 多种方案
   */
  VideoSystem.prototype.ensureVideoAutoplay = function() {
    var self = this;
    
    // 延迟执行，确保DOM完全渲染
    setTimeout(function() {
      // 方案1：检查HTML autoplay属性是否生效
      var videos = self.config.containerEl.querySelectorAll('video');
      var iframes = self.config.containerEl.querySelectorAll('iframe');
      
      self.log('Checking autoplay status:', {
        videos: videos.length,
        iframes: iframes.length
      });
      
      // 方案2：如果HTML autoplay没生效，尝试JavaScript播放
      setTimeout(function() {
        var hasPlayingVideo = false;
        
        // 检查是否有视频在播放
        videos.forEach(function(video) {
          if (!video.paused) {
            hasPlayingVideo = true;
          }
        });
        
        // 如果没有视频在播放，尝试JavaScript播放
        if (!hasPlayingVideo) {
          self.log('No video playing, trying JavaScript autoplay');
          videos.forEach(function(video, index) {
            setTimeout(function() {
              if (video.paused) {
                video.play().catch(function(error) {
                  self.log('JavaScript autoplay failed:', error);
                });
              }
            }, index * 200);
          });
        }
      }, 500);
      
      // 触发resize事件，确保iframe正确显示
      window.dispatchEvent(new Event('resize'));
      
    }, 100);
  };

  /**
   * 从URL同步菜单状态
   */
  function syncMenuStateFromUrl() {
    console.log('同步菜单状态...');
    
    // 检查是否在视频页面
    var isVideoPage = window.location.pathname.includes('leivip-video-page') || 
                     document.querySelector('.section-multi-column[id^="section-id-"]');
    
    if (!isVideoPage) {
      console.log('不在视频页面，跳过菜单状态同步');
      return;
    }
    
    // 从URL获取当前标签
    var url = new URL(window.location.href);
    var currentTab = '';
    
    // 检查所有可能的标签参数
    var tabParams = ['vtab_', 'tab'];
    for (var i = 0; i < tabParams.length; i++) {
      var param = tabParams[i];
      for (var key of url.searchParams.keys()) {
        if (key.startsWith(param)) {
          currentTab = url.searchParams.get(key);
          break;
        }
      }
      if (currentTab) break;
    }
    
    console.log('从URL获取的当前标签:', currentTab);
    
    // 更新菜单按钮状态
    document.querySelectorAll('.video-tab-menu').forEach(function(btn) {
      btn.classList.remove('active-tab');
      
      var btnTab = (btn.getAttribute('data-tab-trigger') || '').trim();
      if (btnTab.toLowerCase() === 'all') btnTab = '';
      
      // 如果URL中没有标签参数，或者标签匹配，则激活该按钮
      if (!currentTab && btnTab === '') {
        btn.classList.add('active-tab');
        console.log('激活 ALL 按钮');
      } else if (currentTab && btnTab === currentTab) {
        btn.classList.add('active-tab');
        console.log('激活标签按钮:', btnTab);
      }
    });
  }

  // 启动系统
  initMultiColumnVideoSystem();
  
  // 页面加载完成后同步菜单状态
  setTimeout(function() {
    syncMenuStateFromUrl();
  }, 100);
  
  // 添加窗口大小变化监听器，确保移动端样式正确应用
  window.addEventListener('resize', function() {
    if (window.videoSystems) {
      Object.keys(window.videoSystems).forEach(function(id) {
        var videoSystem = window.videoSystems[id];
        if (videoSystem && videoSystem.config && videoSystem.config.containerEl) {
          // 重新应用移动端按钮样式
          var renderedItems = videoSystem.config.containerEl.querySelectorAll('.column.text-column');
          renderedItems.forEach(function(el) {
            if (window.innerWidth <= 768) {
              // 移动端应用统一视频高度
              var videoContainers = el.querySelectorAll('.video-container');
              videoContainers.forEach(function(container) {
                container.style.height = '240px';
                container.style.minHeight = '240px';
                container.style.maxHeight = '240px';
              });
              
              // 移动端确保按钮显示
              var buttonRow = el.querySelector('.text-column__button-row');
              if (buttonRow) {
                buttonRow.style.display = 'block';
                buttonRow.style.visibility = 'visible';
                buttonRow.style.opacity = '1';
                buttonRow.style.marginBottom = '20px';
                buttonRow.style.paddingBottom = '10px';
              }
              
              var button = el.querySelector('.text-column__button');
              if (button) {
                button.style.display = 'inline-block';
                button.style.visibility = 'visible';
                button.style.opacity = '1';
                button.style.margin = '8px 0';
                button.style.width = 'auto';
                button.style.minWidth = '120px';
              }
            } else {
              // 桌面端重置样式
              var videoContainers = el.querySelectorAll('.video-container');
              videoContainers.forEach(function(container) {
                container.style.height = '';
                container.style.minHeight = '';
                container.style.maxHeight = '';
              });
              
              var buttonRow = el.querySelector('.text-column__button-row');
              if (buttonRow) {
                buttonRow.style.display = '';
                buttonRow.style.visibility = '';
                buttonRow.style.opacity = '';
                buttonRow.style.marginBottom = '';
                buttonRow.style.paddingBottom = '';
              }
              
              var button = el.querySelector('.text-column__button');
              if (button) {
                button.style.display = '';
                button.style.visibility = '';
                button.style.opacity = '';
                button.style.margin = '';
                button.style.width = '';
                button.style.minWidth = '';
              }
            }
          });
        }
      });
    }
  });
});
